<template>
  <button
      type="button"
      class="history-button"
      :disabled="disabled"
      @click="$emit('click')">
    <img :src="pdfIcon" alt="PDF" class="history-button-icon">

    <span class="history-button-text">{{ label }}</span>
  </button>
</template>

<script setup>
import {defineEmits, defineProps} from 'vue';
import pdfIcon from '@/assets/img/pdf_icon_version4.png';

defineProps({
  label: {
    type: String,
    default: 'Historie'
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

defineEmits(['click'])
</script>

<style scoped>
/* Neutral slate - admin/audit action, intentionally not in the company color */
.history-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 110px;
  white-space: nowrap;
  border: 1px solid #475569;
  color: #475569;
  background-color: #f8fafc;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
}

.history-button:hover:not(:disabled) {
  color: #ffffff;
  background-color: #475569;
}

.history-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Fixed size - the wide coaching table would otherwise shrink the image */
.history-button-icon {
  width: 18px;
  height: 18px;
  min-width: 18px;
  max-width: none;
  flex-shrink: 0;
}

.history-button-text {
  white-space: nowrap;
}
</style>
